<div class='container'>
  <div class='content-card' fxFlex='100'>
    <div class='parent' fxFlex='100'>
      <div class='row'>
        <img src='/assets/images/check.png' alt='' />
      </div>      
      <h2>{{ 'AnnexSuccesfullyCreated' | translate }}</h2>
      <div *ngIf="canSignAsFirst" class='row top-margin'>
        <a mat-raised-button color='primary' class='button' [routerLink]="signAnnexLink">
          {{ 'SAA-SignAnnex' | translate }}
          <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
      <div class='row top-margin'>
        <a mat-raised-button color='primary' class='button' [routerLink]="agreementDetailsLink">
          {{ 'SAA-ShowAnnexesList' | translate }}
          <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
    </div>
  </div>
</div>
